import { getWhitelistedQuery } from 'utils/url';
import { verifyRequiredBetaFeaturesWithUserLoginStatus } from 'utils/betaFeatures/verifyRequiredBetaFeatures';
import { RAVEN_LOGGED_IN_HOMEPAGE_BETA_FEATURE } from './const';
import { LOGGED_OUT_HOMEPAGE_BETA_FEATURE } from '../loggedOutHomePage/const';
import { USER_LOGIN_STATUS } from 'apps/user/helpers';

const shouldDisplayRavenHomepage = verifyRequiredBetaFeaturesWithUserLoginStatus([
  { auth: USER_LOGIN_STATUS.LOGGED_IN, betaFeatures: [RAVEN_LOGGED_IN_HOMEPAGE_BETA_FEATURE] },
  { auth: USER_LOGIN_STATUS.LOGGED_OUT, betaFeatures: [LOGGED_OUT_HOMEPAGE_BETA_FEATURE] },
]);

function redirectToRavenHomapage(nextState, replace) {
  const query = getWhitelistedQuery(nextState.location.query);
  const replaceConfig = {
    pathname: '/home',
    query,
  };

  return replace(replaceConfig);
}

export const redirectsFromLegacyToRavenHomepage = [
  {
    path: 'startWebshop.do',
    onEnterHandlers: [
      shouldDisplayRavenHomepage,
      redirectToRavenHomapage,
    ],
  },
  {
    path: 'displayWelcome.do',
    onEnterHandlers: [
      shouldDisplayRavenHomepage,
      redirectToRavenHomapage,
    ],
  },
];
